var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncludedFood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_Pizza_Slice_Line",
    "data-name": "icons/Pizza Slice/Line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.012,
    height: 26.367,
    viewBox: "0 0 26.012 26.367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M9.5,2.072.752,17.98c-1.429,2.6-.844,5.778,1.944,6.791a30.1,30.1,0,0,0,10.31,1.6,30.1,30.1,0,0,0,10.31-1.6c2.788-1.013,3.373-4.192,1.944-6.791L16.511,2.072A4,4,0,0,0,9.5,2.072ZM4.35,16.972,11.838,3.357a1.333,1.333,0,0,1,2.337,0l7.488,13.615c-.109.057-.23.116-.365.176-1.274.566-3.739,1.218-8.292,1.218s-7.018-.652-8.292-1.218C4.579,17.088,4.458,17.029,4.35,16.972Zm18.6,2.337q-.261.139-.567.275c-1.726.767-4.594,1.448-9.375,1.448s-7.648-.681-9.375-1.448q-.306-.136-.567-.275a2.887,2.887,0,0,0-.337,2,1.278,1.278,0,0,0,.879.95,27.466,27.466,0,0,0,9.4,1.435,27.466,27.466,0,0,0,9.4-1.435,1.278,1.278,0,0,0,.879-.95A2.886,2.886,0,0,0,22.948,19.309Z",
    transform: "translate(0 0)",
    fill: "#23262f",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M6.374,6.992,7.662,9.334A5.333,5.333,0,0,1,2.529,0L3.817,2.343A2.667,2.667,0,0,0,6.374,6.992Z",
    transform: "translate(13.006 5.831)",
    fill: "#23262f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M2.667,1.333A1.333,1.333,0,1,1,1.333,0,1.333,1.333,0,0,1,2.667,1.333Z",
    transform: "translate(9.006 13.033)",
    fill: "#23262f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncludedFood);
export default __webpack_public_path__ + "static/media/includedFood.196ebb6793aa510d808cc58470943551.svg";
export { ForwardRef as ReactComponent };